import React, { FC, ReactNode } from "react";
import style from "./Theme.scss";

export type ThemeType = "dark" | "light";

export interface ThemeProps {
    readonly theme: ThemeType;
    readonly children?: ReactNode;
}

export const Theme: FC<ThemeProps> = props => {
    const { theme } = props;
    return (
        <div className={style[`${theme}Theme`]}>
            {props.children}
        </div>
    );
};
